import gql from 'graphql-tag';

const mutation = gql`
  mutation FavoriteListing($params: FavoriteListingParams!) {
    favoriteListing(params: $params)
  }
`;

export default mutation;
